var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPaymentMcafee = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "payment_mcafee_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "154.24 400.61 771.52 278.79"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".payment_mcafee_svg__cls-1,.payment_mcafee_svg__cls-2{fill:#515458;stroke-width:0}.payment_mcafee_svg__cls-2{fill:#c01818}"))), /*#__PURE__*/React.createElement("g", {
  id: "payment_mcafee_svg___2294862758096",
  "data-name": 2294862758096
}, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "payment_mcafee_svg__Group_906",
  "data-name": "Group 906"
}, /*#__PURE__*/React.createElement("path", {
  id: "payment_mcafee_svg__Path_528",
  "data-name": "Path 528",
  className: "payment_mcafee_svg__cls-2",
  d: "m584.97 481.46-16.73-9.76-.97 1.7a17.83 17.83 0 0 1-15.33 9.06c-10.59.75-19.78-7.22-20.52-17.81-.75-10.59 7.22-19.78 17.81-20.53.9-.06 1.81-.06 2.72 0 6.42-.17 12.38 3.35 15.33 9.06l1.37 1.74 16.73-9.76-1.37-2.09a36.646 36.646 0 0 0-31.7-17.07c-20.69-.89-38.18 15.17-39.07 35.86-.89 20.69 15.17 38.18 35.86 39.07 1.07.05 2.14.05 3.21 0 12.78.04 24.7-6.39 31.7-17.07l.97-2.4Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "payment_mcafee_svg__Group_905",
  "data-name": "Group 905"
}, /*#__PURE__*/React.createElement("path", {
  id: "payment_mcafee_svg__Path_529",
  "data-name": "Path 529",
  className: "payment_mcafee_svg__cls-2",
  d: "M584.27 500.62h23.06l6.97-17.07h34.49l6.97 17.07h22.93l-41.82-99.3h-20.59l5.57 13.23-37.59 86.07Zm47.04-60.28 9.4 23.33h-18.82l9.42-23.33Z"
})), /*#__PURE__*/React.createElement("path", {
  id: "payment_mcafee_svg__Path_530",
  "data-name": "Path 530",
  className: "payment_mcafee_svg__cls-2",
  d: "M687.74 500.62h20.18v-44.61h13.25v-18.8h-13.25v-8.72c-.25-3.97 2.77-7.39 6.74-7.65.19-.01.39-.02.58-.01 1.92-.1 3.83.26 5.59 1.04l2.09 1.04 8.36-18.12-2.44-1.04a41.465 41.465 0 0 0-12.54-2.09 28.053 28.053 0 0 0-21.6 8.72 28.133 28.133 0 0 0-6.97 19.22v8.02h-9.06v18.75h8.72l.38 44.25Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "payment_mcafee_svg__Path_531",
  "data-name": "Path 531",
  className: "payment_mcafee_svg__cls-2",
  d: "M417.7 400.61v100h21.96v-57.14l21.26 15.69 21.25-15.69v57.14h21.96v-100l-43.21 32.75-43.22-32.75Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "payment_mcafee_svg__Path_532",
  "data-name": "Path 532",
  className: "payment_mcafee_svg__cls-2",
  d: "M766.1 426.05c-20.59-.88-38 15.09-38.88 35.68-.88 20.59 15.09 38 35.68 38.88 1.07.05 2.13.05 3.2 0 12-.33 23.29-5.78 31-14.97l-16.37-9.06a21.242 21.242 0 0 1-14.99 6.62 17.85 17.85 0 0 1-17.42-12.54h54.71v-4.87c1.01-20.92-15.14-38.69-36.06-39.7l-.88-.03Zm-17.42 27.88c2.31-6.63 8.65-11.01 15.67-10.8 7.17-.13 13.68 4.16 16.37 10.8h-32.05Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "payment_mcafee_svg__Path_533",
  "data-name": "Path 533",
  className: "payment_mcafee_svg__cls-2",
  d: "M848.4 426.05c-20.59-.88-38 15.09-38.88 35.68-.88 20.59 15.09 38 35.68 38.88 1.07.05 2.13.05 3.2 0 12-.33 23.28-5.78 31-14.97l-16.37-9.06c-3.9 4.12-9.3 6.5-14.97 6.62a17.85 17.85 0 0 1-17.42-12.54h54.71v-4.87c1-20.93-15.16-38.7-36.08-39.7l-.86-.03Zm-17.49 28.22c2.31-6.63 8.65-11.01 15.67-10.8 7.17-.13 13.68 4.16 16.37 10.8H830.9Z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  id: "payment_mcafee_svg___2294862758960",
  "data-name": 2294862758960
}, /*#__PURE__*/React.createElement("path", {
  id: "payment_mcafee_svg__Path_534",
  "data-name": "Path 534",
  className: "payment_mcafee_svg__cls-1",
  d: "M894.92 524.99h12.76v2.65h-5.33v13.83h-2.66v-13.83h-5.31v-2.65h.54Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "payment_mcafee_svg__Path_535",
  "data-name": "Path 535",
  className: "payment_mcafee_svg__cls-1",
  d: "M909.8 524.99h3.72l4.57 12.76 3.95-12.76h3.72v15.95h-1.99v-12.35l-4.19 12.35h-2.5l-4.63-12.23v12.23h-2.66v-15.95Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "payment_mcafee_svg___2294862758816",
  "data-name": 2294862758816
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "payment_mcafee_svg__Path_536",
  "data-name": "Path 536",
  className: "payment_mcafee_svg__cls-2",
  d: "M204.21 591.11v-113.2l71.04 33.57V456.9l-121.01-56.27v222.5l121.01 56.27v-54.71l-71.04-33.57Z"
})), /*#__PURE__*/React.createElement("path", {
  id: "payment_mcafee_svg__Path_537",
  "data-name": "Path 537",
  d: "M347.07 591.11v-113.2l-71.82 33.57V456.9l121-56.27v222.5l-121 56.27v-54.71l71.82-33.57Z",
  style: {
    fill: "#75160d",
    strokeWidth: 0
  }
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "payment_mcafee_svg__Path_538",
  "data-name": "Path 538",
  className: "payment_mcafee_svg__cls-1",
  d: "m417.7 617.72 6.34-15.4a34.698 34.698 0 0 0 19.97 7.15c10.07 0 15.1-3.51 15.1-10.53-.06-3.46-1.33-6.78-3.58-9.4a45.702 45.702 0 0 0-14.69-10.03 69.245 69.245 0 0 1-15-9.13 24.33 24.33 0 0 1-5.94-8.52 27.93 27.93 0 0 1-2.09-10.98c-.16-7.1 2.86-13.91 8.24-18.56a30.209 30.209 0 0 1 21.05-7.37c8.66-.69 17.31 1.52 24.58 6.27L466.49 546a32.21 32.21 0 0 0-19.05-6.48c-3.36-.21-6.67.91-9.2 3.13-2.2 2.12-3.39 5.07-3.27 8.13 0 5.49 6.13 11.24 18.39 17.24 5.05 2.24 9.76 5.18 14 8.73 2.81 2.59 5.03 5.75 6.52 9.26a29.99 29.99 0 0 1 2.24 11.83c.12 7.51-3.31 14.63-9.26 19.22a37.818 37.818 0 0 1-24.79 7.58c-8.63.13-17.1-2.28-24.38-6.92Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  id: "payment_mcafee_svg___1",
  "data-name": 1,
  className: "payment_mcafee_svg__cls-1",
  d: "M508.27 541.85v22.54h31.31v14.58h-31.31v28.82h43.85v15.25h-60.99v-96.49h60.99v15.25l-43.85.06Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  id: "payment_mcafee_svg___2",
  "data-name": 2,
  className: "payment_mcafee_svg__cls-1",
  d: "m634.15 531.74-7.05 14.16a25.534 25.534 0 0 0-18.47-5.67c-7.86-.1-15.26 3.68-19.79 10.1a40.712 40.712 0 0 0-7.71 25.53c-.47 8.75 2.05 17.4 7.15 24.53a23.067 23.067 0 0 0 19.09 9.07c8.29.38 16.24-3.26 21.37-9.79l7.99 13.83a40.07 40.07 0 0 1-30.74 11.2 38.823 38.823 0 0 1-31.44-13.29 54.417 54.417 0 0 1-11.21-36.28 52.819 52.819 0 0 1 12.44-35.78 40.18 40.18 0 0 1 31.83-14.37c9.33-.46 18.59 1.88 26.57 6.74Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  id: "payment_mcafee_svg___3",
  "data-name": 3,
  className: "payment_mcafee_svg__cls-1",
  d: "M650.45 526.6h17.13v65.36c-.54 9.13 6.42 16.98 15.56 17.52.74.04 1.48.04 2.22-.02 5.24.31 10.41-1.39 14.44-4.76 3.53-3.4 5.42-8.17 5.17-13.07V526.6h17.13v66.36a28.81 28.81 0 0 1-9.99 23.33 39.818 39.818 0 0 1-26.63 8.43c-9.37.61-18.62-2.33-25.91-8.24a30.042 30.042 0 0 1-9.13-23.57v-66.32Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  id: "payment_mcafee_svg___4",
  "data-name": 4,
  className: "payment_mcafee_svg__cls-1",
  d: "m796.42 623.08-25.82-39.8c-2.61 0-6.24-.16-10.88-.47v40.28h-17.84v-96.58c.96 0 4.68-.15 11.13-.49s11.68-.49 15.63-.49c24.54 0 36.81 9.5 36.8 28.51.04 5.63-1.75 11.12-5.08 15.66-3.16 4.53-7.61 8-12.78 9.96l28.51 43.44h-19.67Zm-36.71-81.64v26.85c3.17.27 5.59.41 7.25.41 5.41.37 10.83-.68 15.72-3.05 3.66-2.76 5.55-7.26 4.97-11.8.36-4.09-1.73-8-5.33-9.98a37.35 37.35 0 0 0-16.8-2.84c-1.94.01-3.87.15-5.79.41h-.01Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  id: "payment_mcafee_svg___5",
  "data-name": 5,
  className: "payment_mcafee_svg__cls-1",
  d: "M841.47 541.85v22.54h31.31v14.58h-31.31v28.82h43.85v15.25h-60.99v-96.49h60.99v15.25l-43.85.06Z"
}))));
export default SvgPaymentMcafee;